import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './StatsGrid.css';

const PLACEHOLDER_STATS = [
  { id: 1, label: 'Active Positions', color: 'blue' },
  { id: 2, label: 'Monthly P&L', color: 'green' },
  { id: 3, label: 'Total P&L', color: 'gold' },
];

const StatsGrid = () => {
  const [stats, setStats] = useState(PLACEHOLDER_STATS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/profile/stats');
      if (response.data.success) {
        setStats(response.data.data.stats);
      }
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (id) => {
    switch (id) {
      case 1:
        return (
          <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
            <path d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 2:
        return (
          <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
            <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 3:
        return (
          <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
            <path d="M16 8L8 16M8.5 8.5H8.51M15.5 15.5H15.51M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`stats-grid ${loading ? 'stats-grid--loading' : ''}`}>
      {stats.map((stat, index) => (
        <div 
          key={stat.id} 
          className={`stats-grid__card stats-grid__card--${stat.color}`}
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <div className="stats-grid__card-header">
            <div className="stats-grid__icon-wrapper">
              {getIcon(stat.id)}
            </div>
            {stat.trend && (
              <span className="stats-grid__trend">
                <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {stat.trend}
              </span>
            )}
          </div>
          <div className="stats-grid__card-body">
            {loading ? (
              <span className="stats-grid__value-skeleton" aria-hidden="true" />
            ) : (
              <span className="stats-grid__value">{stat.value}</span>
            )}
            <span className="stats-grid__label">{stat.label}</span>
          </div>
          <div className="stats-grid__card-glow"></div>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;
